import { IJobCandidateInteraction } from 'wisestep-api';

export const CandidateSearchDefaultRequest: IJobCandidateInteraction = {
  id: '',
  workspaceId: '',
  query: '',
  totalResults: '',
  timeTakenInMillis: 0,
  page: 0,
  size: 20,
  sort: ['createdOn,desc'],
  workspaceName: '',
  sources: [],
  tags: [],
  employers: [],
  currentEmployers: [],
  clientNames: [],
  candidateLinkedInURL: '',
  candidateProfileURLs: [],
  candidateLocations: [],
  candidateAllLocationFields: [],
  workAuthorizationCategories: [],
  candidateName: '',
  languages: [],
  salaryCurrency: '',
  minSalary: 0,
  maxSalary: 0,
  radiusInMiles: 0,
  searchScope: 'EVERYTHING',
  searchWithMostRecentConversation: true,
};
